import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ApiVisa,
  Pagination, AppletNotificationTemplateContainerModel, AppletNotificationTemplateService
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-email-template',
  templateUrl: './select-email-template.component.html',
  styleUrls: ['./select-email-template.component.css']
})
export class SelectEmailTemplateComponent implements OnInit, OnDestroy {
  @Input() apiVisa: ApiVisa;
  @Input() emailTemplate: FormControl;
  @Input() txn_type: string;
  @Output() selectedEmailTemplate = new EventEmitter<AppletNotificationTemplateContainerModel>();

  private subs = new SubSink();
  pagination = new Pagination();
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<AppletNotificationTemplateContainerModel[]> = new ReplaySubject<AppletNotificationTemplateContainerModel[]>(1);
  emailTemplateList: AppletNotificationTemplateContainerModel[];

  constructor(private emailTemplateService: AppletNotificationTemplateService) { }

  ngOnInit() {
    this.pagination.conditionalCriteria = [
      { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
      { columnName: 'txn_type', operator: '=', value: this.txn_type },
    ];
    this.subs.sink = this.emailTemplateService.getByCriteria(this.pagination, this.apiVisa).subscribe(
      {
        next: resolve => {
          this.emailTemplateList = resolve.data;
          this.filteredOptions$.next(this.emailTemplateList);
        }
      });
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({ next: resolve => this.filterEmailTemplates(resolve) });
  }

  filterEmailTemplates(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.emailTemplateList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.emailTemplateList.filter(c => c.bl_applet_notification_template_hdr.code?.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const pf = this.emailTemplateList.find(i => i.bl_applet_notification_template_hdr.guid === e)
    this.selectedEmailTemplate.emit(pf);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}